const React = require('react');
const { useTranslation } = require('react-i18next');
const { getWeekTypeDisplayName } = require('@managers/planningManager');

const NoPlanningMessage = ({
  weekType,
  weekRange,
  onPrev,
  onNext,
  isPrevDisabled,
  isNextDisabled,
  messageType = 'no_irrigation_planning_this_week', // default message type
}) => {
  const { t } = useTranslation();

  // Determine the message based on messageType
  const getMessage = () => {
    return t(messageType);
  };

  // Get translated week type display name using planningManager
  const headerTitle = getWeekTypeDisplayName(weekType);

  return (
    <div className='irrigation-card'>
      <div className='irrigation-card__header'>
        <span>{t(headerTitle)}</span>
        <span className='irrigation-card__date'>{weekRange}</span>
      </div>
      <div className='irrigation-card__stats-row'>
        <button
          onClick={onPrev}
          disabled={isPrevDisabled}
          aria-label='Previous week'
          className='irrigation-card__arrow'
        >
          <img
            src={require('images/icons/Chevron_left.svg')}
            alt='Previous week'
            style={{ width: 16, height: 16 }}
          />
        </button>
        <div className='irrigation-card__no-planning-message'>
          {getMessage()}
        </div>
        <button
          onClick={onNext}
          disabled={isNextDisabled}
          aria-label='Next week'
          className='irrigation-card__arrow'
        >
          <img
            src={require('images/icons/Chevron_right.svg')}
            alt='Next week'
            style={{ width: 16, height: 16 }}
          />
        </button>
      </div>
    </div>
  );
};

module.exports = NoPlanningMessage;
